var ServerInterceptor_1;
import { __decorate } from "tslib";
import { Injectable, isDevMode } from "@angular/core";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { throwError } from "rxjs";
import { AppConfig } from "../../../app.config";
import { catchError, tap } from "rxjs/operators";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { HttpStatusCodeEnum } from "../../models/http-status-code-enum.model";
import { AuthService } from "../auth/auth.service";
import { AppControllerService } from "../../../app-controller.service";
import { RequestStatusService } from "../request-status/request-status.service";
import { SharedConstants } from "../../constants/shared.constants";
const CONTENT_TYPE = "application/json";
export let ServerInterceptor = class ServerInterceptor {
    static { ServerInterceptor_1 = this; }
    appControllerService;
    authService;
    requestStatusService;
    authenticationToken;
    constructor(appControllerService, authService, requestStatusService) {
        this.appControllerService = appControllerService;
        this.authService = authService;
        this.requestStatusService = requestStatusService;
        this.listenForAuthenticationTokenChanges();
    }
    static checkForUnAuthenticated(httpResponse) {
        return httpResponse.status === +HttpStatusCodeEnum.UnAuthorized;
    }
    static configureUrl(request) {
        const apiUrl = AppConfig.settings.api.server + "/api";
        return request.url.replace(AppRoutingConstants.API_PREFIX, apiUrl);
    }
    static isRequestValidForProgressUpdate(request) {
        const headers = request.headers;
        const showProgressHeader = headers.get("Progress");
        if (headers.get("Progress")) {
            if (showProgressHeader === "false") {
                return false;
            }
        }
        return true;
    }
    intercept(req, next) {
        if (!req.url.startsWith(AppRoutingConstants.API_PREFIX)) {
            return this.handleNonApiRequest(req, next);
        }
        else {
            return this.handleApiRequest(req, next);
        }
    }
    handleUnAuthenticated() {
        this.authService.authenticate();
    }
    listenForAuthenticationTokenChanges() {
        this.authService.$authenticationToken.subscribe((tokenChange) => {
            this.authenticationToken = tokenChange;
        });
    }
    handleNonApiRequest(request, next) {
        this.showBusySpinnerForRequest(request);
        return this.executePipelineActions(request, next, request);
    }
    handleApiRequest(request, next) {
        let url = ServerInterceptor_1.configureUrl(request);
        url = this.checkIfBusyIndicatorMustShow(url);
        this.showBusySpinnerForRequest(request, url);
        const serverRequest = this.setHeaders(request, url);
        return this.executePipelineActions(serverRequest, next, request);
    }
    checkIfBusyIndicatorMustShow(url) {
        return url.replace(SharedConstants.NOT_BUSY_INDICATOR, "");
    }
    executePipelineActions(request, next, oldRequest) {
        return next.handle(request).pipe(tap(evt => {
            if (evt instanceof HttpResponse) {
                this.handleResponse(evt, request, oldRequest);
            }
        }), catchError((err) => {
            return this.handleHttpError(err, request, oldRequest);
        }));
    }
    handleResponse(evt, request, oldRequest) {
        this.removeBusySpinnerForRequest(request, oldRequest);
        if (!isDevMode()) {
            this.showResponseContent(evt);
        }
    }
    showResponseContent(evt) {
        if (evt.body) {
            this.appControllerService.showConsoleMessage(evt.body);
        }
        else {
            this.appControllerService.showConsoleMessage(JSON.stringify(evt));
        }
    }
    setHeaders(request, url) {
        if (request.body instanceof FormData) {
            return request.clone({
                setHeaders: {
                    Authorization: "Bearer " + this.authenticationToken
                },
                url,
                withCredentials: true
            });
        }
        else {
            return request.clone({
                setHeaders: {
                    Accept: CONTENT_TYPE,
                    "Content-Type": "application/json; charset=utf-8",
                    "X-Requested-With": "XMLHttpRequest",
                    Authorization: "Bearer " + this.authenticationToken
                },
                url,
                body: JSON.stringify(request.body),
                withCredentials: true
            });
        }
    }
    handleHttpError(err, request, oldRequest) {
        this.removeBusySpinnerForRequest(request, oldRequest);
        if (err instanceof HttpErrorResponse) {
            if (ServerInterceptor_1.checkForUnAuthenticated(err)) {
                this.handleUnAuthenticated();
            }
            if (!isDevMode()) {
                this.appControllerService.showConsoleMessage(JSON.stringify(err));
            }
        }
        return throwError(err);
    }
    showBusySpinnerForRequest(request, url = null) {
        if (request.url.includes(SharedConstants.NOT_BUSY_INDICATOR) || url && url.includes(SharedConstants.NOT_BUSY_INDICATOR))
            return;
        if (ServerInterceptor_1.isRequestValidForProgressUpdate(request)) {
            if (url == null) {
                this.requestStatusService.showBusySpinner(request.url);
            }
            else {
                this.requestStatusService.showBusySpinner(url);
            }
        }
    }
    removeBusySpinnerForRequest(request, oldRequest) {
        if (oldRequest.url.includes(SharedConstants.NOT_BUSY_INDICATOR)) {
            return;
        }
        this.requestStatusService.removeBusySpinner(request.url);
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: AuthService },
        { type: RequestStatusService }
    ];
};
ServerInterceptor = ServerInterceptor_1 = __decorate([
    Injectable()
], ServerInterceptor);
